import ApiService from "@/common/api.service";
import {
  FETCH_SERVICE_REPORTS,
  FETCH_SERVICE_REPORT,
  UPDATE_SERVICE_REPORT,
  CREATE_SERVICE_REPORT,
  RESET_SERVICE_REPORT,
  DELETE_SERVICE_REPORT,
  FETCH_SERVICE_REPORTS_FOR_ISSUE
} from "./actions.type";
import {
  FETCH_SERVICE_REPORT_START,
  SET_SERVICE_REPORTS,
  SET_SERVICE_REPORT,
  SET_SERVICE_REPORTS_FOR_ISSUE
} from "./mutations.type";

const state = {
  serviceReports: [],
  serviceReportsCount: 1,
  serviceReport: {
    spare_part: {}
  },
  isLoading: false
};

const getters = {
  serviceReportsCount: state => state.serviceReportsCount,
  serviceReports: state => state.serviceReports,
  serviceReport: state => state.serviceReport,
  serviceReportIsLoading: state => state.isLoading,
};

const actions = {
  [FETCH_SERVICE_REPORTS]({ commit }, [filteringCriteria, search, filters]) {
    commit(FETCH_SERVICE_REPORT_START);
    return ApiService.filteredCollection(
      "service-reports",
      filteringCriteria,
      search,
      filters
    ).then(({ data }) => {
      commit(SET_SERVICE_REPORTS, data);
    });
  },
  [FETCH_SERVICE_REPORT](context, id) {
    return ApiService.get("service-reports", id).then(({ data }) => {
      context.commit(SET_SERVICE_REPORT, data);
    });
  },
  [UPDATE_SERVICE_REPORT](context, payload) {
    return ApiService.put(`service-reports/${payload.id}`, payload);
  },
  [CREATE_SERVICE_REPORT](context, payload) {
    return ApiService.post("service-reports", payload);
  },
  [RESET_SERVICE_REPORT](context) {
    context.commit(SET_SERVICE_REPORT, {
      spare_part: {},
    });
  },
  [DELETE_SERVICE_REPORT](context, id) {
    return ApiService.delete("service-reports", id);
  },
  [FETCH_SERVICE_REPORTS_FOR_ISSUE]({ commit }, issueId) {
    commit(FETCH_SERVICE_REPORT_START);
    return ApiService.get(`service-reports/issue/${issueId}`).then(
      ({ data }) => {
        commit(SET_SERVICE_REPORTS_FOR_ISSUE, data);
      }
    );
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_SERVICE_REPORT_START](state) {
    state.isLoading = true;
  },
  [SET_SERVICE_REPORTS](state, data) {
    state.serviceReports = data.items || [];
    state.serviceReportsCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_SERVICE_REPORT](state, data) {
    state.serviceReport = data;
    state.isLoading = false;
  },
  [SET_SERVICE_REPORTS_FOR_ISSUE](state, data) {
    state.serviceReports = data;
    state.serviceReportsCount = 0;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
